import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './../../assets/no-data.png'


const _withScopeId = n => (_pushScopeId("data-v-828976e0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "post-list-page" }
const _hoisted_2 = { class: "post-header" }
const _hoisted_3 = { class: "search-content" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_5 = { class: "filter-content df" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "filter-type" }, "工作地点", -1))
const _hoisted_7 = { class: "filter-item-content" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "separate" }, null, -1))
const _hoisted_10 = {
  key: 0,
  class: "post-list-content"
}
const _hoisted_11 = { class: "post-list" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "post-basic-info" }
const _hoisted_14 = { class: "df aic" }
const _hoisted_15 = { class: "post-name" }
const _hoisted_16 = {
  key: 0,
  class: "post-salary"
}
const _hoisted_17 = {
  key: 1,
  class: "post-salary"
}
const _hoisted_18 = {
  key: 2,
  class: "post-isUrgent"
}
const _hoisted_19 = { class: "df aic" }
const _hoisted_20 = { class: "other-info" }
const _hoisted_21 = { class: "other-info" }
const _hoisted_22 = { class: "other-info" }
const _hoisted_23 = {
  key: 0,
  class: "other-info"
}
const _hoisted_24 = {
  key: 1,
  class: "other-info"
}
const _hoisted_25 = { class: "other-info" }
const _hoisted_26 = { class: "other-info" }
const _hoisted_27 = { class: "post-basic-info" }
const _hoisted_28 = { class: "post-company-name" }
const _hoisted_29 = { class: "post-address" }
const _hoisted_30 = { class: "pagination-block" }
const _hoisted_31 = { key: 1 }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "no-data" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("span", { class: "no-data-info" }, "暂无职位")
], -1))
const _hoisted_33 = [
  _hoisted_32
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_affix, { offset: 0 }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.searchText,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
              type: "text",
              size: "large",
              placeholder: "请输入职位名称",
              class: "input-search",
              "prefix-icon": _ctx.Search,
              onKeyup: _withKeys(_ctx.searchPost, ["enter"])
            }, {
              append: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.searchPost
                }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }, 8, ["modelValue", "prefix-icon", "onKeyup"])
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addressList, (item, index) => {
          return (_openBlock(), _createElementBlock("span", {
            key: index,
            class: _normalizeClass(["filter-item", { 'filter-item-active': index === _ctx.activeIndex }]),
            onClick: ($event: any) => (_ctx.filterList(item, index))
          }, _toDisplayString(item.regionName), 11, _hoisted_8))
        }), 128))
      ])
    ]),
    _hoisted_9,
    (_ctx.postList && _ctx.postList.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.postList, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                onClick: ($event: any) => (_ctx.toDetail(item)),
                class: "post-item df aic jcsb"
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, _toDisplayString(item.postName), 1),
                    (item.salaryRangeText !== '面议')
                      ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(item.salaryRangeText) + "元/月", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_17, "薪资面议")),
                    (item.isUrgent)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_18, "急聘"))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(item.cityName), 1),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(item.conditionEducationName), 1),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(item.conditionExperienceName), 1),
                    (item.isAgeLimit)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(item.ageMin) + "-" + _toDisplayString(item.ageMax) + "岁", 1))
                      : (_openBlock(), _createElementBlock("span", _hoisted_24, "不限年龄")),
                    _createElementVNode("span", _hoisted_25, _toDisplayString(item.workTypeName), 1),
                    _createElementVNode("span", _hoisted_26, _toDisplayString(item.postTypeName), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, _toDisplayString(item.customerName), 1),
                  _createElementVNode("div", _hoisted_29, _toDisplayString(item.address), 1)
                ])
              ], 8, _hoisted_12))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_30, [
            _createVNode(_component_el_pagination, {
              currentPage: _ctx.currentPage,
              "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currentPage) = $event)),
              "page-size": _ctx.pageSize,
              "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pageSize) = $event)),
              layout: "total, sizes, prev, pager, next, jumper",
              total: _ctx.totalPost,
              onSizeChange: _ctx.handleSizeChange,
              onCurrentChange: _ctx.handleCurrentChange
            }, null, 8, ["currentPage", "page-size", "total", "onSizeChange", "onCurrentChange"])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_33))
  ]))
}